// core version + navigation, pagination modules:
import Swiper from "swiper";
import { Pagination } from "swiper/modules";

// configure Swiper to use modules
Swiper.use([Pagination]);

(function () {
  const newsSlider = document.querySelectorAll(".news-slider");
  let newsSwiper = [];

  for (let i = 0; i < newsSlider.length; i++) {
    newsSwiper[i] = new Swiper(newsSlider[i], {
      loop: false,
      slidesPerView: 1,
      spaceBetween: 15,
      pagination: {
        el: ".news-swiper-pagination",
        clickable: true,
      },
    });
  }
})();
